/* ============================================================
   PETAL.PK — GLOBAL SCRIPT (sst-)
   ============================================================ */
(function () {
  'use strict';

  /* ---- 1. Reveal on scroll ---- */
  function initReveal() {
    var els = document.querySelectorAll('.sst-rv');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sst-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('sst-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: .12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- 2. Sticky bar ---- */
  function initStickyBar() {
    var bar = document.querySelector('[data-sst-stickybar]');
    if (!bar) return;
    var triggerSel = bar.getAttribute('data-trigger');
    var trigger = triggerSel ? document.querySelector(triggerSel) : null;
    var offset = parseInt(bar.getAttribute('data-offset') || '0', 10);
    function onScroll() {
      var past = trigger ? window.scrollY > trigger.offsetTop + offset : window.scrollY > 600;
      bar.classList.toggle('sst-show', past);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- 3. Anchor resolver ----
     The menu links use short hashes like #how, #colours, #bundles, #reviews,
     #faq, #buy. The real section wrappers have ids like "sst-how-<sid>".
     Resolve each hash to the best-matching element on the CURRENT page. */
  function resolveTarget(hash) {
    if (!hash) return null;
    var id = hash.replace(/^#/, '');
    if (!id) return null;
    var exact = document.getElementById(id);
    if (exact) return exact;
    var bySstPrefix = document.querySelector('[id^="sst-' + id + '-"]')
      || document.querySelector('[id^="sst-' + id + '"]');
    if (bySstPrefix) return bySstPrefix;
    var byClass = document.querySelector('.sst-' + id + '-section');
    if (byClass) return byClass;
    return null;
  }

  function closeDrawer() {
    var drawer = document.querySelector('.sst-header__drawer');
    var overlay = document.querySelector('.sst-header__overlay');
    var burger = document.querySelector('.sst-header__burger');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.setAttribute('aria-hidden', 'true');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  function headerOffset() {
    var header = document.querySelector('.sst-header');
    if (!header) return 0;
    var pos = window.getComputedStyle(header).position;
    return (pos === 'sticky' || pos === 'fixed') ? header.offsetHeight : 0;
  }

  function scrollToTarget(target, smooth) {
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.scrollY - headerOffset() - 12;
    window.scrollTo({ top: top, behavior: smooth ? 'smooth' : 'auto' });
  }

  /* On load: if the URL carries a hash that maps to a section here, scroll to it.
     This handles arriving from another page (e.g. /policies/... -> /#how). */
  function handleInitialHash() {
    if (!window.location.hash || window.location.hash.length <= 1) return;
    var target = resolveTarget(window.location.hash);
    if (!target) return;
    /* wait a tick so layout (images, fonts) settles, then jump */
    setTimeout(function () { scrollToTarget(target, false); }, 60);
    /* and once more after full load for late-shifting content */
    window.addEventListener('load', function () {
      setTimeout(function () { scrollToTarget(resolveTarget(window.location.hash), false); }, 120);
    });
  }

  function initNavSpy() {
    var navLinks = Array.prototype.slice.call(
      document.querySelectorAll('.sst-header__links a, .sst-header__drawer-links a')
    );
    if (!navLinks.length) return;

    var anchorLinks = [];

    navLinks.forEach(function (a) {
      var href = a.getAttribute('href') || '';
      var hashIndex = href.indexOf('#');
      if (hashIndex === -1) return;
      var hash = href.slice(hashIndex);
      if (hash.length <= 1) return;

      var localTarget = resolveTarget(hash);
      if (localTarget) {
        anchorLinks.push({ el: a, hash: hash, target: localTarget });
      }

      a.addEventListener('click', function (e) {
        var t = resolveTarget(hash);
        if (t) {
          /* section is on THIS page — smooth scroll in place */
          e.preventDefault();
          scrollToTarget(t, true);
          if (history.replaceState) history.replaceState(null, '', hash);
          closeDrawer();
        } else {
          /* section NOT on this page — navigate to homepage + hash.
             Rewrite href so the browser goes to the site root with the hash,
             then handleInitialHash() on the homepage finishes the scroll. */
          var rootHref = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          if (rootHref.charAt(rootHref.length - 1) === '/') rootHref = rootHref.slice(0, -1);
          a.setAttribute('href', rootHref + '/' + hash);
          closeDrawer();
          /* let the browser follow the (now corrected) link */
        }
      });
    });

    if (!anchorLinks.length || !('IntersectionObserver' in window)) return;

    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        anchorLinks.forEach(function (item) {
          item.el.classList.toggle('sst-nav-active', item.target === entry.target);
        });
      });
    }, { rootMargin: '-25% 0px -60% 0px' });

    anchorLinks.forEach(function (item) { spy.observe(item.target); });
  }

  function init() {
    initReveal();
    initStickyBar();
    initNavSpy();
    handleInitialHash();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
